module.exports = __webpack_public_path__ + "c6332efa735bd527e4092297391c752d.svg";